import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './loading-spinner.module.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  text = '加载中...'
}) => {
  const sizeMap = {
    sm: 24,
    md: 40,
    lg: 64,
  };

  return (
    <div className={styles.container}>
      <Loader2 
        className={styles.spinner} 
        size={sizeMap[size]} 
      />
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
